"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewLoginAsPartner extends new_item_1.default {
    constructor(newLoginAsPartner) {
        super();
        this.username = newLoginAsPartner.username;
        this.user = newLoginAsPartner.user;
        this.token = newLoginAsPartner.token;
        this.mfaRequired = newLoginAsPartner.mfaRequired;
        this.expires = newLoginAsPartner.expires;
        this.scope = newLoginAsPartner.scope;
        this.tokenType = newLoginAsPartner.tokenType;
        this.partnerOverride = newLoginAsPartner.partnerOverride;
    }
}
exports.default = NewLoginAsPartner;
//# sourceMappingURL=new-loginAsPartner.js.map